import React, { useEffect } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../../Usuario/components/BannerPanel";
import { MenuUsuario } from "../../Usuario/components/MenuUsuario";
import { Footer } from "../../../components/Landing/Footer";
import { useNavigate } from "react-router";
// styled components
import { Row, Col, Button, Tabs, Alert } from "antd";
import MisPostulacionesJurado from "../Regiterform/MisPostulacionesJurado";
import { InscribirJurado } from "../Regiterform/inscribirJurado";
import { InscribirButtonJurado } from "../Regiterform/inscribirButtonJurado";
import "../Regiterform/styleCss.scss";
import { useInscribirHojaJurados } from "../../../hooks/useInscribirHojaJurados";
import { EstadoFormularioComponent } from "../components/EstadoFormulario";
import { ProyectosEvaluar } from "../../Usuario/EvaluacionProyectos/ProyectosEvaluar";
import { SubsanarDocumentos } from "./components/SubsanarDocumentos";
import EvaluacionProyectosList from "../Regiterform/EvaluacionProyectosList";
import EvaluacionProyectos from "../Regiterform/EvaluacionProyecto";
import { HistorialEvaluación } from "../Regiterform/HistorialEvaluación";

export const MenuJurado = () => {
  const {
    jurado,
    consultarJurado,
    messageNoJurado,
    lineasConvocatorias,
  } = useInscribirHojaJurados();

  useEffect(() => {
    consultarJurado();
  }, []);

  return (
    <div>
      <Header />
      <BannerPanel />
      <div className="container-fluid2">
        <div className="row mt-4 mb-4">
          <MenuUsuario activeItem={1} />
          {messageNoJurado ? (
            <div className="col-12 col-md-9" style={{ paddingTop: "30px" }}>
              <Alert
                message="Si ha sido seleccionado como Jurado y no cargan los proyectos por favor refrescar la página. O en su defecto cierre sesión e inicie de nuevo."
                type="warning"
              />
            </div>
          ) : (
            <>
              <div className="col-12 col-lg-10">
                {jurado === undefined ? null : (
                  <div className="row justify-content-center">
                    <div className="col-12 font-size-14px font-family-Montserrat-Bold">
                      <Tabs
                        className="height-100 col background-color-FFFFFF no margin"
                        defaultActiveKey="1"
                      >
                        <Tabs.TabPane
                          tab="Mis Postulaciones"
                          key="1"
                          className="height-100 font-size-13px font-family-Montserrat-Regular"
                        >
                          Mi Información de Jurado.
                          <MisPostulacionesJurado/>
                        </Tabs.TabPane>
                        <Tabs.TabPane
                          tab="Evaluación proyectos"
                          key="2"
                          className="height-100 font-size-13px font-family-Montserrat-Regular"
                        >
                          <EvaluacionProyectosList
                            jurado={jurado}
                            lineasConvocatorias={lineasConvocatorias}
                          />
                          <EvaluacionProyectos />
                        </Tabs.TabPane>
                      </Tabs>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
